<template>
  <div class="card mg-t-20">
    <div class="card-header d-flex justify-content-between">
      <h6 class="mg-b-0">{{title}}</h6>
      <!-- <nav class="nav nav-row-xs align-items-center">
                  <a
                    @click="
                      restrictedDaysData.params.mode = 2;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 2 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1W</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 3;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 3 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1M</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 4;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 4 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >1Y</a
                  >
                  <a
                    @click="
                      restrictedDaysData.params.mode = 5;
                      loadHyazgaarlalt();
                    "
                    :class="
                      `nav-link ${
                        restrictedDaysData.params.mode == 5 ? 'active' : ''
                      }`
                    "
                    role="button"
                    >ALL</a
                  >
                </nav> -->
    </div>
    <div class="card-body" >
      <div id="chart">
        <apexchart type="line" height="350" :options="chartOptions" :series="series"></apexchart>
      </div>
    </div>
    <div class="card-footer tx-11 tx-color-03" >
      Боловсруулсан: 0.20сек
              </div>
  </div>
</template>

<script>
// import "element-ui/lib/theme-chalk/index.css";
// import { DatePicker } from "element-ui";
import VueApexCharts from "vue-apexcharts";
// import AsyncLoadError from "@/components/base/asyncLoadingError";
// import AsyncLoading from "@/components/base/asyncLoading";

const moment = require("moment");
import { request } from "@/api/all";

export default {
  components: {
    apexchart: VueApexCharts,
  },
  props:{
    title: {
      type: String,
      default: () => ''
    },
    url: {
      type: String,
      default: () => ''
    }
  },
  data() {
    return {
      series: [
            {
              name: "Патент",
              data: [28, 29, 33, 36, 32, 32, 33]
            },
            {
              name: "Зохиогчийн эрх",
              data: [12, 11, 14, 18, 17, 13, 13]
            },
            {
              name: "Үндэсний стандарт",
              data: [17, 26, 22, 30, 26, 24, 27]
            }
          ],
          chartOptions: {
            chart: {
              height: 350,
              type: 'line',
              dropShadow: {
                enabled: true,
                color: '#000',
                top: 18,
                left: 7,
                blur: 10,
                opacity: 0.2
              },
              toolbar: {
                show: false
              }
            },
            colors: ['#77B6EA', '#545454', '#ffc107'],
            dataLabels: {
              enabled: true,
            },
            stroke: {
              curve: 'smooth'
            },
            title: {
              text: 'Оюуны өмчийн төрлөөр',
              align: 'left'
            },
            grid: {
              borderColor: '#e7e7e7',
              row: {
                colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.5
              },
            },
            markers: {
              size: 1
            },
            xaxis: {
              categories: ['1-р сар', '2-р сар', '3-р сар', '4-р сар', '5-р сар', '6-р сар', '7-р сар'],
              title: {
                text: 'Сар'
              }
            },
            yaxis: {
              title: {
                text: 'Үзүүлэлт'
              },
              min: 5,
              max: 40
            },
            legend: {
              position: 'top',
              horizontalAlign: 'right',
              floating: true,
              offsetY: -25,
              offsetX: -5
            }
          },
    };
  },
  mounted() {
    // this.loadVehicleCount();
  },
  methods: {
    toggleBodyClass(addRemoveClass, className) {
      const el = document.body;

      if (addRemoveClass === "addClass") {
        el.classList.add(className);
      } else {
        el.classList.remove(className);
      }
    },
    // loadVehicleCount() {
    //   this.toggleBodyClass("addClass", "dynamic-locker");
    //   request({
    //     api: { method: "GET", url: this.url },
    //     params: {
    //       mode: this.restrictedDaysData.params.mode,
    //       startDate: this.restrictedDaysData.params.startDate,
    //       endDate: this.restrictedDaysData.params.endDate,
    //     },
    //     store: this.$store,
    //   }).then((res) => {
    //     this.toggleBodyClass("removeClass", "dynamic-locker");
    //     if (res != false) {
    //       console.log('res', res);
    //       this.restrictedDaysData.data = res.data;
    //       this.seriesDays[0].data = res.data.list.map((x) => {
    //         return x.count;
    //       });
    //       this.chartDaysOptions.xaxis.categories = res.data.list.map((x) => {
    //         return x.typeName;
    //       });
    //       this.chartDaysOptionsKey++;
    //       this.restrictedDaysData.rdy = true;
    //     }
    //   });
    // },
  },
};
</script>
